import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SitePictureComponent } from './site-picture.component';
import { CoreModule } from 'app/core/core.module';

@NgModule({
  imports: [
    CommonModule,
    CoreModule
  ],
  declarations: [
    SitePictureComponent
  ],
  entryComponents: [SitePictureComponent]
})
export class SitePictureModule { }